export default __webpack_public_path__ + "71aee942d30933476589146f39df64a6.svg";